import React from 'react'
import { ModelWithForm, SubmitFormOnPipe, WhenLoaded } from '@morningtrain/react-resources'
import { RouteParameterFilter } from 'support/filters'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import OnOrderReadPipeline from 'support/pipelines/inventory/OnOrderReadPipeline'
import { EnvField, RouteParameterField, SelectedDepartmentField } from 'support/fields'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import OrderItems from './partials/OrderItems'
import OrderPageHeader from 'pages/app/inventory/order/partials/OrderPageHeader'
import InventoryOrderDaysCalculator from 'widgets/inventory/InventoryOrderDaysCalculator'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'
import OnEventPipeline from 'services/events/OnEventPipeline'
import WhenOrderIsDraft from 'pages/app/inventory/order/partials/WhenOrderIsDraft'
import ConfirmFormChanges from "support/pipelines/ConfirmFormChanges";

export default function Edit () {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='inventory.order'>
        <ModelWithForm resourceName='inventory.order' autoFetch={false} clean>
          <ConfirmFormChanges />
          <RouteParameterFilter name='inventory_order' />
          <WhenOrderIsDraft>
            <OnEventPipeline name='auto-logout'>
              <SubmitFormOnPipe data={{ status: 'draft' }} />
            </OnEventPipeline>
          </WhenOrderIsDraft>

          <RedirectToEditOnCreatePipeline
            routeName='app.inventory.order.edit'
            extraRouteParameters={{ inventory_supplier: 'payload:route.parameters.inventory_supplier' }}
          />

          {/* Pipeline triggered whenever a new order is loaded - It loads and sets up related data */}
          <OnOrderReadPipeline />

          {/* Page header with info cards */}
          <OrderPageHeader />

          <WhenLoaded>
            {/* Base form fields */}
            <SelectedDepartmentField />
            <InventoryOrderDaysCalculator />
            <EnvField path='globals.inventory.delivery_days.order_for_start' name='order_for_start' />
            <EnvField path='globals.inventory.delivery_days.order_for_end' name='order_for_end' />
            <EnvField path='globals.inventory.delivery_days.weekdays_count' name='weekdays_count' />
            <RouteParameterField name='supplier_id' parameterName='inventory_supplier' />

            <WhenEnvValueMatches name='globals.department.id' negate>
              <Translation name='no_department' />
            </WhenEnvValueMatches>

            {/* All available items for the current order */}
            <OrderItems />

          </WhenLoaded>

        </ModelWithForm>
      </Translator>
    </AdminPageWithSmartview>
  )
}
